import React from "react";

export default function SiteLayout({ children }) {
  return (
    <div className="site-shell min-h-screen overflow-x-hidden font-sans text-gray-800">
      {children}
    </div>
  );
}
